import { getService } from 'react-in-angularjs';
import { apiService } from '../../shared/services/apiService';
import { ChildInformation, Subscription } from '../interfaces/ChildInformation';

type GetSubscriptionsResponse = {
  subscriptions: Subscription[];
};

const basePath = 'api/public/pre-check-in/';

const attachPaymentMethod = async (paymentMethodId: string) => {
  const { token } = getService('$routeParams');
  const params = { paymentMethod: paymentMethodId };

  await apiService.put(`${basePath}card-details/${token}`, null, { params });
};

const setChildRegisterRequestStatus = async (
  approved: boolean,
  isRunGlobalSpinner?: boolean,
) => {
  const { token } = getService('$routeParams');
  const data = { approved };

  await apiService.post(basePath + token, data, { isRunGlobalSpinner });
};

const getChildInfo = async () => {
  const { token } = getService('$routeParams');

  const resp = await apiService.get<ChildInformation>(`${basePath}${token}`);

  return resp.data;
};

const getSubscriptions = async (entityId: string) => {
  const params = { entityID: entityId };

  const resp = await apiService.get<GetSubscriptionsResponse>(
    'api/coach/pre-check-in/subscriptions',
    { params },
  );

  return resp.data;
};

export const preCheckInService = {
  attachPaymentMethod,
  setChildRegisterRequestStatus,
  getChildInfo,
  getSubscriptions,
};
